import { PLAN_CATALOG, PLAN_PRICES, PLAN_RANK } from '../config/pricing';

export const getPlanName = (planId, fallback = 'Silver') => {
    const plan = PLAN_CATALOG.find((entry) => entry.id === planId);
    return plan?.name ?? fallback;
};

export const getPlanPrice = (planId) => PLAN_PRICES[planId] ?? null;

export const isUpgrade = (currentPlanId, targetPlanId) => {
    if (!currentPlanId || !targetPlanId) {
        return false;
    }
    const currentRank = PLAN_RANK[currentPlanId];
    const targetRank = PLAN_RANK[targetPlanId];
    return currentRank != null && targetRank != null && targetRank > currentRank;
};

export const isDowngrade = (currentPlanId, targetPlanId) => {
    if (!currentPlanId || !targetPlanId || currentPlanId === targetPlanId) {
        return false;
    }
    return !isUpgrade(currentPlanId, targetPlanId);
};

export const formatScheduleDate = (dateValue) => {
    if (!dateValue) return '';
    return new Date(dateValue).toLocaleDateString('en-IN', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
};

export const isManageableSubscription = (status) =>
    status === 'active' || status === 'trial';

export const getGuestCtaLabel = (trialEligible) =>
    (trialEligible ? 'Start free trial' : 'Get started');

export const getPlanCtaClassName = (popular) =>
    `block w-full py-3 rounded-lg font-semibold text-center transition-all duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 ${popular
        ? 'bg-amber-600 text-white hover:bg-amber-700 shadow-lg hover:shadow-xl focus-visible:ring-amber-500'
        : 'bg-indigo-600 text-white hover:bg-indigo-700 shadow-lg hover:shadow-xl focus-visible:ring-indigo-500'
    }`;

